import { render, staticRenderFns } from "./AddResource.vue?vue&type=template&id=21ef1888&scoped=true"
import script from "./AddResource.vue?vue&type=script&lang=js"
export * from "./AddResource.vue?vue&type=script&lang=js"
import style0 from "./AddResource.vue?vue&type=style&index=0&id=21ef1888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ef1888",
  null
  
)

export default component.exports